import { Space, Typography } from '@ag1/ui';
import { SocialMedia } from 'types/studio/studio';
import clsx from 'clsx';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { StudioBaseIconV2 } from '../../StudioBaseIcon/StudioBaseIcon';
import styles from './SocialMediaProfileLink.module.scss';

type Props = {
  socialProfile?: SocialMedia['socialProfile'];
  bgColor?: SocialMedia['bgColor'];
  theme?: SocialMedia['theme'];
};

const SocialMediaProfileLink = ({ socialProfile, bgColor, theme }: Props) => (
  <Space top={{ xxs: 16, s: 24, l: 32 }}>
    <div className={styles.linkWrapper}>
      {socialProfile?.icon?.asset && (
        <StudioBaseIconV2 icon={socialProfile.icon} className={styles.icon} />
      )}
      <a
        href={socialProfile?.link}
        target="_blank"
        rel="noreferrer noopener"
        aria-label={`${socialProfile?.linkText} (Opens in a new tab)`}>
        <Typography
          variant="subtitle"
          size="1"
          noPadding
          className={clsx(
            styles.linkText,
            bgColor === 'grey' && styles.bgGrey,
            getThemeCSSClass(theme)
          )}
          weight="700">
          {socialProfile?.linkText}
        </Typography>
      </a>
    </div>
  </Space>
);

export default SocialMediaProfileLink;
